import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { companyManagementUrl } from "../../../config";
import { useEffect, useState } from "react";
import { BranchColumns } from "../../../data/DynamicTable/CompanyManagementColumns";
import {
  allCompanyBranchesView,
  allRegions,
} from "../../../data/Axios/queries";
import BranchForm from "./form";
import { graphqlQuery } from "../../../data/Axios/DynamicService";

const base_url = companyManagementUrl.uri;

const actions = {
  entity: "Company Branches",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  showStatus: true,
};

function BranchTable() {
  const [regionData, setRegionData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAllData() {
      try {
        const regionDataResponse = await graphqlQuery(allRegions, base_url);
        if (regionDataResponse) setRegionData(regionDataResponse);
      } catch (error) {
        console.error("Error fetching regions:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, []);

  
  return (
    <Box m="2px">
      <DynamicTable
        title="Branch"
        subtitle="Create, view or edit Branch"
        columns={BranchColumns}
        FormComponent={BranchForm}
        query={allCompanyBranchesView}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default BranchTable;
